import styled from 'styled-components'

//* utils
import { ASSETS } from '../../../../constants/assets'
import ImgUtil from '../../../../utils/img.utils'

//* components
import Breadcrumbs from '../../../global/breadcrumbs'
import Typography from '../../../global/typography'

export const StyledBreadcrumbs = styled(Breadcrumbs)``

export const heroTitle = styled(Typography)`
  margin: 0;
  text-shadow: none;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`

export const heroSubheadline = styled.p`
  margin-top: 16px;
  color: ${({ theme }) => theme.webMktNewPalette.black};
  font-size: 20px;
  font-weight: normal;
  letter-spacing: -0.5px;
  line-height: 32px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-top: 8px;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    margin-top: 16px;
  }
`

export const HeroOuter = styled.div`
  ${({ theme }) => {
    return `
      max-width: 1920px;
      margin: 0 auto;
      ${heroTitle},${heroSubheadline} {
        max-width: 972px;
      }
      
      .Hero__Container {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        position: relative;
        background-color: ${theme.webMktNewPalette.white};
        padding: 24px 0 0 0;

        ${theme.breakpoints.down('sm')} {
          padding: 16px;
        }

        ${theme.breakpoints.down('xs')} {
          box-sizing: border-box;
          max-width: 736px;
        }
      }

      .Hero__Top-Items {
        z-index: 2;
        position: relative;
      }

      .Hero__Main-Img-Grid-BG {
        position: absolute;
        top: 0;
        right: 0;

        ${theme.breakpoints.down('sm')} {
          width: 100%;
        }
        
        .Hero__Main-Img-Grid-BG-Img {
          z-index: 0;
          position: relative;
          width: 1037px;
          height: 619px;
          right: -96px;
          background-repeat: no-repeat;
          background-size: 1037px auto;
          background-image: url(${ImgUtil.getResizedImageUrl(
            ASSETS.CUSTOMER_STORY_BACKGROUND,
            'width=1680'
          )});
          
          ${theme.breakpoints.down('md')} {
            width: 868px;
            height: 498px;
            right: -80px;
            background-size: 868px auto;
            background-image: url(${ImgUtil.getResizedImageUrl(
              ASSETS.CUSTOMER_STORY_BACKGROUND_MD,
              `width=1280`
            )});
          }

          ${theme.breakpoints.down('sm')} {
            width: 531px;
            height: 432px;
            right: 0;
            background-image: url(${ImgUtil.getResizedImageUrl(
              ASSETS.CUSTOMER_STORY_BACKGROUND_SM,
              `width=850`
            )});
            background-size: 531px auto;
            margin-left: auto;
          }

          ${theme.breakpoints.down('xs')} {
            width: 100%;
            height: 124px;
            background-image: none;
            margin-top: 54px;

            &:before {
              content: '';
              background-image: radial-gradient(rgb(127,127,127) 1px, transparent 0);
              position: absolute;
              width: 100%;
              height: 124px;
              background-size: 24px 24px;
            }
          }
        }

        .Hero__Main-Img {
          z-index: 1;
          position: absolute;
          top: 64px;
          right: 0;
          width: 588px;
          height: 330px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          ${theme.breakpoints.down('md')} {
            width: 468px;
            height: 262px;
          }

          ${theme.breakpoints.down('sm')} {
            width: 360px;
            height: 202px;
            top: 49px;
          }

          ${theme.breakpoints.down('xs')} {
            width: 328px;
            height: 184px;
            top: 96px;
            left: 50%;
            padding: 0 16px;
            transform: translateX(-50%);
          }

          .Hero__Main-Img-File {
            width: 100%;
            height: auto;
            min-height: 100%;
            object-fit: cover;
          }
        }
      }

      ${heroTitle} {
        color: ${theme.webMktNewPalette.black};
      }

      .Hero__Logo {
        width: 280px;
        height: 140px;
        padding: 106px 0 0 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        ${theme.breakpoints.down('md')} {
          padding: 46px 0 0 0;
        }

        ${theme.breakpoints.down('sm')} {
          padding: 19px 0 0 0;
          width: 240px;
          right: 120px;
        }

        ${theme.breakpoints.down('xs')} {
          width: 172px;
          height: 77px;
          background: ${theme.webMktNewPalette.white};
          padding: 0;
          margin-top: 204px;
          justify-content: flex-end;
          align-items: flex-start;
        }

        .Hero__Logo-File {
          width: 100%;
          height: auto;
          ${theme.breakpoints.down('xs')} {
            width: 128px;
          }
        }
      }

      .Hero__Text-Meta {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        .Hero__Text-Meta-Item {
          margin-right: 24px;
          margin-bottom: 8px;

          .Hero__Eyebrow-Grey {
            color: ${theme.webMktNewPalette.deepBlue[55]};
            margin-right: 6px;
          }
        }
      }

      .Hero__Text {
        padding: 40px 104px 0 0;
        background: ${theme.webMktNewPalette.white};
        width: 894px;
        box-sizing: border-box;

        ${theme.breakpoints.down('md')} {
          width: 714px;
          padding: 40px 82px 0 0;
        }

        ${theme.breakpoints.down('sm')} {
          width: 564px;
          padding: 24px 16px 0 0;
        }

        ${theme.breakpoints.down('xs')} {
          width: 100%;
          padding: 0;
          margin-top: 34px;
        }
      }

      .Hero__Text-H1 {
        margin: 8px 0 64px 0;
      }
    `
  }}
`
